export default "__VITE_ASSET__DKwQBMz5__"